module.exports = __webpack_public_path__ + "static/img/icon-export-disabled.8f498c95.svg";